import { styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const Spinner = styled('div')(() => ({
  '&.spinner': {
    textAlign: 'center',

    '&.spinner-page': {
      marginTop: '250px',
      marginBottom: '250px',
    },

    '&.vehicle-details': {
      paddingTop: '280px',
    },

    '&.vehicle-overview': {
      marginTop: '50px',
    },
  },
}));
